import { CATEGORY_STYLE_BY_KEY } from './constants';

const stripDiacritics = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

const normalizeText = (value) =>
  String(value || '')
    .replace(/\s+/g, ' ')
    .trim();

export const normalizeCategoryKey = (value) =>
  stripDiacritics(normalizeText(value))
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '') || 'geral';

export const formatCategoryLabel = (categoryKey, fallbackLabel = '') => {
  const fallback = normalizeText(fallbackLabel);
  if (fallback) {
    return fallback;
  }

  if (CATEGORY_STYLE_BY_KEY[categoryKey]?.label) {
    return CATEGORY_STYLE_BY_KEY[categoryKey].label;
  }

  return categoryKey
    .split('-')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
};

export const getFavoriteSectionAccentClassName = (categoryKey) => {
  return (
    CATEGORY_STYLE_BY_KEY[categoryKey]?.accentClassName ||
    'bg-slate-100 text-slate-700 border-slate-200'
  );
};

export const getFavoriteSectionEmptyMessage = (categoryKey) => {
  return (
    CATEGORY_STYLE_BY_KEY[categoryKey]?.emptyMessage ||
    'Nenhum favorito enviado nessa categoria ainda.'
  );
};
